import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import About from './pages/About';
import ServiceDetail from './pages/Services';
import Events from './pages/Events';
import Courses from './pages/Courses';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import Speaker from './pages/Speaker';
import { BlogList, BlogPost } from './pages/Blog';
import GiftCard from './pages/GiftCard';
import Unsubscribe from './pages/Unsubscribe';
import ReportBug from './pages/ReportBug/ReportBug';
import NotFound from './pages/NotFound/NotFound';
import './styles/global.css';

function App() {
  return (
    <HelmetProvider>
      <Router basename="/">
        <div className="App">
          <Header />
          <main>
            <Routes>
              {/* Main pages */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/about" element={<About />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/speaker" element={<Speaker />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/gift-card" element={<GiftCard />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/report-bug" element={<ReportBug />} />

              {/* Old WordPress URL redirects (indexed on Google) */}
              <Route path="/book-online" element={<Navigate to="/booking" replace />} />
              <Route path="/intuitive-reiki-healings" element={<Navigate to="/services/reiki" replace />} />
              <Route path="/intuitive-tarot-readings" element={<Navigate to="/services/tarot" replace />} />
              <Route path="/holistic-life-coaching" element={<Navigate to="/services/soul-coaching" replace />} />
              <Route path="/chakra-balancing" element={<Navigate to="/services/chakra" replace />} />
              <Route path="/space-clearing" element={<Navigate to="/services/space-clearing" replace />} />
              <Route path="/finding-forgiveness" element={<Navigate to="/blog/finding-forgiveness" replace />} />
              <Route path="/bringing-healing-energy-to-sydneys-north-shore" element={<Navigate to="/blog/bringing-healing-energy-to-sydneys-north-shore" replace />} />
              <Route path="/product/gift-card" element={<Navigate to="/gift-card" replace />} />
              <Route path="/blogs" element={<Navigate to="/blog" replace />} />

              {/* Catch-all 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
